export const getDemoApi = "/api/demo";